import {ADD_TOAST_MESSAGE} from "vuex-toast";

export default {
  methods: {
    toastError(message) {
      this.$store.dispatch(
        ADD_TOAST_MESSAGE,
        {text: message, type: "danger"},
        {root: true}
      );
    },
    toastSuccess(message) {
      this.$store.dispatch(
        ADD_TOAST_MESSAGE,
        {text: message, type: "success"},
        {root: true}
      );
    },
  }
}